var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0d0d0d;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,104.7c8.5,2.2,17.5,3.3,26.7,3.3,58.5,0,106.2-46.6,107.9-104.7-8.5-2.2-17.5-3.3-26.7-3.3C49.5,0,1.8,46.6,0,104.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.4,109.5c-8.2-7.3-15.4-14.3-21.5-21-6.1-6.6-9.2-12.8-9.2-18.6s1.5-8.3,4.6-11.4c3.1-3.1,6.9-4.6,11.4-4.6s5.2.7,7.8,2.2c2.6,1.4,4.9,3.4,6.9,5.8,2-2.4,4.3-4.4,6.9-5.8,2.6-1.4,5.2-2.2,7.8-2.2,4.5,0,8.3,1.5,11.4,4.6,3.1,3.1,4.6,6.9,4.6,11.4s-3.1,12-9.2,18.6c-6.1,6.6-13.3,13.6-21.5,21ZM132.4,98.7c5.8-5.2,11-10.4,15.7-15.6s7.1-9.5,7.1-13.1-.8-4.3-2.3-5.8-3.5-2.3-5.8-2.3-2.9.3-4.4,1c-1.4.7-2.9,2-4.4,3.9l-5.9,7.2-5.9-7.2c-1.5-1.9-2.9-3.2-4.4-3.9-1.4-.7-2.9-1-4.4-1-2.4,0-4.3.8-5.8,2.3-1.5,1.5-2.3,3.5-2.3,5.8,0,3.6,2.4,7.9,7.1,13.1s10,10.3,15.7,15.6ZM121.9,161.4l-40.7-11.7v7.5h-28.2v-51.6h40.5l33.4,12.6c2.4.9,4.3,2.3,6,4.3,1.6,2,2.4,4.8,2.4,8.4h14.9c3.7,0,6.7,1.3,9.2,3.9,2.4,2.6,3.7,6.2,3.7,10.6v3.4l-41.1,12.6h0ZM60.9,149.3h12.3v-35.9h-12.3s0,35.9,0,35.9ZM121.4,153.3l33.5-10.2c-.5-1.7-1.2-2.8-2-3.4-.8-.6-1.7-.9-2.8-.9h-27.1c-2.6,0-5-.2-7.3-.5-2.2-.3-4.3-.8-6.4-1.4l-10.6-3.3,2.9-7.6,9.6,3.1c2.2.7,4.3,1.2,6.2,1.4,2,.3,5.1.4,9.4.4,0-1-.2-2.1-.6-3.1-.4-1-1.1-1.7-2-2.2l-32.1-12.2h-11v28l40.2,11.8h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1Dark);
export default __webpack_public_path__ + "static/media/icon-1-dark.08216fdc72e5ec3475ce21dead48e1fd.svg";
export { ForwardRef as ReactComponent };